// libs
import { styled } from '@nykaa/ui-components';

export const Container = styled.div<{ hideCoachMark: boolean }>`
  position: absolute;
  z-index: 9;
  bottom: -60px;
  max-width: 142px;
  ${({ theme }) => theme.typography.bodySmall};
  ${({ theme, hideCoachMark }) => `
  background: ${theme.colors.surfaceInverse};
  border-radius: ${theme.borders.radius30};
  padding: ${theme.spacing.spacing40};
  box-shadow: ${theme.elevations.shadow300};
  display: ${hideCoachMark ? 'none' : 'block'};
  `};

  .triangle {
    left: 14px;
    width: 0;
    height: 0;
    border-left: 20px solid ${({ theme }) => theme.colors.surfaceInverse};
    border-bottom: 20px solid #00000000;
    border-top-left-radius: 6px;
    transform: rotate(45deg);
    position: absolute;
    top: -9px;
  }

  .text {
    ${({ theme }) => `
  color: ${theme.colors.surface};
  `};
  }
`;
